import React from 'react';
import { Col, ColProps, Form, FormInstance, Input, Row } from 'antd';
import FormInput from 'components/FormInput';
import BankListSelect from 'components/BankListSelect';
import BankBranchListSelect from 'components/BankBranchListSelect';
import { isNil } from 'lodash';
import Value from 'components/Value';
import { ibanValidator } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';

export type BankProps = {
  form?: FormInstance;
  bankField?: string;
  branchField?: string;
  cbkeyField?: string;
  cbnumField?: string;
  codePostalField?: string;
  ibanField?: string;
  bicField?: string;
  banknameField?: string;
  countcode: string;
  currcode: string;
  notRequired?: boolean;
  colU?: number;
  Colw?: ColProps;
  lancode?: any;
  labelcol?: any;
  disabled?: boolean;
};
const Bank = ({
  disabled = false,
  countcode,
  currcode,
  bankField = 'bank',
  branchField = 'branch',
  cbkeyField = 'tpcbkey',
  cbnumField = 'tpcbnum',
  ibanField = 'tpiban',
  bicField = 'tpbic',
  banknameField = 'tpbankname',
  notRequired,
  colU,
  form,
  Colw,
  lancode,
  labelcol,
}: BankProps) => {
  return (
    <Col span={24}>
      <Form.Item shouldUpdate noStyle>
        {({ setFieldsValue, getFieldValue, validateFields }) => (
          <>
            <Row gutter={16}>
              <FormInput
                col
                xs={colU ? colU : 5}
                name={bankField}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <BankListSelect
                  disabled={disabled}
                  paramsprop={{
                    countcode: countcode
                      ? countcode
                      : getFieldValue('countcode'),
                  }}
                  onSelected={(bank) => {
                    setFieldsValue({
                      [bicField]: bank?.bkbic,
                      [banknameField]: bank?.bkname,
                      tpiban1: bank?.bkibanprefix
                        ? bank?.bkibanprefix?.concat(bank?.bkcode)
                        : bank?.bkcode,
                      [branchField]: '',
                      [cbnumField]: '',
                      [cbkeyField]: '',
                      [branchField]: '',
                      [ibanField]: bank?.bkibanprefix
                        ? bank?.bkibanprefix?.concat(bank?.bkcode)
                        : bank?.bkcode,
                    });
                    validateFields([ibanField]);
                  }}
                  allowClear
                />
              </FormInput>
              <FormInput
                col
                xs={colU ? colU : 5}
                name={branchField}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <BankBranchListSelect
                  disabled={disabled}
                  paramsprop={{ bkcode: getFieldValue([bankField]) }}
                  onSelected={(bank) => {
                    if (!isNil(getFieldValue('tpiban1'))) {
                      setFieldsValue({
                        [ibanField]: getFieldValue('tpiban1')
                          ?.concat(bank?.bkbranchcode)
                          ?.concat(getFieldValue([cbnumField]))
                          ?.concat(getFieldValue([cbkeyField])),
                      });
                    } else {
                      let iban = getFieldValue(ibanField).slice(
                        0,
                        getFieldValue(ibanField).indexOf(
                          getFieldValue([bankField])
                        ) + getFieldValue([bankField]).length
                      );
                      setFieldsValue({
                        [ibanField]: iban
                          ?.concat(bank?.bkbranchcode)
                          ?.concat(getFieldValue([cbnumField]))
                          ?.concat(getFieldValue([cbkeyField])),
                        tpiban1: iban,
                      });
                    }
                    validateFields([ibanField]);
                  }}
                  allowClear
                />
              </FormInput>
              <FormInput
                col
                xs={lancode === 'FR' ? 6 : colU ? colU : 6}
                name={cbnumField}
                wrapperCol={Colw}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <Input
                  disabled={disabled}
                  prefix={getFieldValue(branchField)?.slice(3)}
                  onChange={(val) => {
                    if (!isNil(getFieldValue('tpiban1'))) {
                      setFieldsValue({
                        [ibanField]: getFieldValue('tpiban1')
                          ?.concat(getFieldValue([branchField]))
                          ?.concat(val?.target?.value)
                          ?.concat(getFieldValue([cbkeyField])),
                      });
                    } else {
                      let iban = getFieldValue(ibanField)?.slice(
                        0,
                        getFieldValue(ibanField)?.indexOf(
                          getFieldValue([branchField])
                        ) - 1
                      );
                      setFieldsValue({
                        [ibanField]: iban
                          ?.concat(getFieldValue([branchField]))
                          ?.concat(val?.target?.value)
                          ?.concat(getFieldValue([cbkeyField])),
                        tpiban1: iban,
                      });
                    }
                    validateFields([ibanField]);
                  }}
                  allowClear
                />
              </FormInput>
              <FormInput
                col
                xs={colU ? colU : 5}
                name={cbkeyField}
                wrapperCol={lancode === 'FR' ? { span: 10 } : {}}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <Input
                  disabled={disabled}
                  onChange={(val) => {
                    if (!isNil(getFieldValue('tpiban1'))) {
                      setFieldsValue({
                        [ibanField]: getFieldValue('tpiban1')
                          ?.concat(getFieldValue([branchField]))
                          ?.concat(getFieldValue([cbnumField]))
                          ?.concat(val?.target?.value),
                      });
                    } else {
                      let iban = getFieldValue(ibanField)?.slice(
                        0,
                        getFieldValue(ibanField).indexOf(
                          getFieldValue([branchField])
                        ) - 1
                      );
                      setFieldsValue({
                        [ibanField]: iban
                          ?.concat(getFieldValue([branchField]))
                          ?.concat(getFieldValue([cbnumField]))
                          ?.concat(val?.target?.value),
                        tpiban1: iban,
                      });
                    }
                    validateFields([ibanField]);
                  }}
                  allowClear
                />
              </FormInput>
            </Row>
            <Row gutter={16}>
              <FormInput
                name={ibanField}
                wrapperCol={Colw}
                labelCol={labelcol ? labelcol : { span: 5 }}
                col
                xs={colU ? colU : 5}
                rules={[
                  notRequired
                    ? { required: false , message: ' ' }
                    : { required: true ,  message:  localStorage?.getItem('lancode') === 'FR'?'Veuillez insérer un IBAN':'Please fill the bank account information' },

                  ({ getFieldValue }) => ({
                    validator() {
                      const pattern = ibanValidator(getFieldValue(ibanField));

                      if (pattern || countcode !== 'MA' || currcode !== 'MAD') {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Iban invalide'));
                    },
                  }),
                ]}
              >
                <Value />
              </FormInput>
              <FormInput
                col
                xs={colU ? colU : 5}
                labelCol={labelcol ? labelcol : { span: 5 }}
                wrapperCol={Colw}
                name={bicField}
              >
                <Input disabled={disabled} />
              </FormInput>
              <FormInput
                col
                xs={lancode === 'FR' ? 8 : colU ? colU : 6}
                name={banknameField}
                wrapperCol={Colw}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <Input disabled={disabled} />
              </FormInput>
              <FormInput
                col
                xs={colU ? colU : 5}
                name="tpcbtype"
                wrapperCol={Colw}
                labelCol={labelcol ? labelcol : { span: 5 }}
              >
                <ParListSelect parcode="BKACLASS" disabled={disabled} />
              </FormInput>
            </Row>
          </>
        )}
      </Form.Item>
    </Col>
  );
};

export default Bank;
